import { useMutation } from '@tanstack/react-query';
import signupApi from '@/features/auth/signup/api/signupApi.ts';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { queryClient } from '@/App.tsx';
import { userApiQueryKeys } from '@/features/dashboard/_root/api/userApi.queryKeys.ts';
import { UnauthenticatedError } from '@/lib/api/exception.ts';
import { clearStoredCompanyId } from '@/features/dashboard/_root/access/currentCompany.ts';

export default function useCompleteProfile() {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: signupApi.completeSignup,
    onSuccess: () => {
      // Nowa firma ma być widoczna do wyboru, a nie przykryta starym wyborem.
      clearStoredCompanyId();
      queryClient.removeQueries({ queryKey: userApiQueryKeys.me() });
      toast.success('Twoje dane zostały zapisane pomyślnie');
      navigate({ to: '/app/dashboard' });
    },
    onError: (error: Error) => {
      if (error instanceof UnauthenticatedError) {
        navigate({
          to: '/auth/login',
          search: { emailVerified: true },
        });
        return;
      }
      toast.error('Wystąpił błąd podczas zapisywania danych.', {
        description: error.message,
      });
    },
  });
}
